import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { CheckCircleIcon } from '@phosphor-icons/react/CheckCircle';
import { MinusCircleIcon } from '@phosphor-icons/react/MinusCircle';
import type { ReactNode } from 'react';
import { type AudienceListType, ListType } from '../../../types.ts';
import { getHoverableItemStyles } from './utils/hoverableItemStyles.ts';

type BaseHoverableItemProps = {
  children: ReactNode;
  type: AudienceListType;
};

export type HoverableItemProps = BaseHoverableItemProps &
  ({ readOnly: true } | { readOnly?: false; onDelete: () => void; isNested?: boolean });

export const HoverableItem = ({ children, type, ...rest }: HoverableItemProps) => {
  const theme = useTheme();
  const styles = getHoverableItemStyles({
    readOnly: !!rest.readOnly,
    isNested: 'isNested' in rest ? rest.isNested : undefined,
  });

  return (
    <Box sx={styles.root}>
      <Box sx={styles.iconBox}>
        {type === ListType.INCLUDES ? (
          <CheckCircleIcon data-test="check-icon" color={theme.palette.success.main} size={20} />
        ) : (
          <MinusCircleIcon data-test="block-icon" color={theme.palette.error.main} size={20} />
        )}
      </Box>

      <Box sx={styles.contentBox}>{children}</Box>

      {!rest.readOnly && (
        <Box className="hoverable" sx={styles.hoverableBox}>
          <IconButton size="small" sx={styles.closeButton} onClick={rest.onDelete}>
            <CloseIcon data-test="close-icon" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
